import React from "react";

export const Download = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 11.4926C17.3905 11.1021 17.3905 10.4691 17 10.0786C16.6095 9.68814 15.9765 9.68814 15.586 10.0786L13.8536 11.811C13.5386 12.126 13 11.9029 13 11.4575V3C13 2.44771 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V11.4575C11 11.9029 10.4614 12.126 10.1464 11.811L8.414 10.0786C8.02354 9.68814 7.39046 9.68814 7 10.0786C6.60953 10.4691 6.60953 11.1021 6.99999 11.4926L11.2929 15.7856C11.6834 16.1761 12.3166 16.1761 12.7071 15.7856L17 11.4926ZM4 19C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H4Z" fill="white"/>
        </svg>
    );
};
